import { render, staticRenderFns } from "./Loaders.vue?vue&type=template&id=af57f1e6&scoped=true"
import script from "./Loaders.vue?vue&type=script&lang=js"
export * from "./Loaders.vue?vue&type=script&lang=js"
import style0 from "./Loaders.vue?vue&type=style&index=0&id=af57f1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af57f1e6",
  null
  
)

export default component.exports